import { render } from "./LocalHighScore.vue?vue&type=template&id=fc0708e8&scoped=true"
import script from "./LocalHighScore.vue?vue&type=script&lang=js"
export * from "./LocalHighScore.vue?vue&type=script&lang=js"

import "./LocalHighScore.vue?vue&type=style&index=0&id=fc0708e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc0708e8"]])

export default __exports__